import script from "./ParceirosCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./ParceirosCadastro.vue?vue&type=script&setup=true&lang=js"

import "./ParceirosCadastro.vue?vue&type=style&index=0&id=29093568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29093568"]])

export default __exports__